import { uniqueId } from 'js/utils/methods.util';

import { TServerSendRequest } from '../../types';

export const updateCorrelationId = <RequestData>(request: TServerSendRequest<RequestData>): TServerSendRequest<RequestData> => {
    let updatedRequest = request;

    if (!updatedRequest.correlationId) {
        updatedRequest = {
            ...updatedRequest,
            correlationId: uniqueId('correlationId_')
        };
    }

    if (updatedRequest.requests) {
        updatedRequest = {
            ...updatedRequest,
            requests: updatedRequest.requests.map((req) => ({
                ...req,
                correlationId: updatedRequest.correlationId
            }))
        };
    }

    return updatedRequest;
};

export const addRelativeUri = <RequestData>(request: TServerSendRequest<RequestData>): TServerSendRequest<RequestData> => {
    const { pathname, search } = window.location;

    return {
        ...request,
        relativeURI: `${pathname}${search}`
    };
};
